import React, { Component } from 'react';
import santahat from './images/santa-hat.svg';

class SelectPerson extends Component {
	// handleAddPersonChild = (e) => {
	// 	e.preventDefault();
	// 	const trimName = e.target.elements.name.value.trim();
	// 	this.props.handleAddPersonParent(trimName);
	// 	document.getElementById("name-form").reset();
	// }

	componentDidUpdate(prevProps) {
		// Популярный пример (не забудьте сравнить пропсы):
		// if (this.props.options !== prevProps.options) {
		this.generateOptions(this.props.options);
		// }
	}

	generateOptions = () => {
		return (
			<select type="text" name="login" className="input" defaultValue="Select a name..." style={{ padding: '16px 32px', border: 'none', borderRadius: '0.8rem', fontSize: '16px', margin: '16px 0' }}>
				<option value="Select a name...">Select a name...</option>
				{this.props.options.map((el, index) => {
					return <option key={index} value={el.name.replace(" ", "%")}>{el.name}</option>
				})}
			</select>
		)
	}

	render() {
		return (
			<form autoComplete="off"
				// onSubmit={this.handleAddPersonChild}
				id="login-form" className="login-form">
				{this.generateOptions()}

				<input type="password" name="password" className="input" placeholder="Enter a password" style={{ width: '100%', borderRadius: '0.8rem', padding: 0, lineHeight: '51px', paddingLeft: '32px', maxWidth: 'calc(100% - 32px)' }} />

				<button className="generate-button" type="submit">
					<img src={santahat} className="santa-icon" alt="santa-icon" />
					LOGIN
				</button>
			</form>
		)
	}
}

export default SelectPerson;